// extracted by mini-css-extract-plugin
module.exports = {"payment-method-icons":"payment-method-icons-module__payment-method-icons___I59NP","paymentMethodIcons":"payment-method-icons-module__payment-method-icons___I59NP"};